module.exports = __webpack_public_path__ + "static/media/HeyAliceMono-Regular.6d8b9386.woff";